import type { FaireProductEntity } from "../../entity_types/product";

export const p_8z8qtkmbja: FaireProductEntity = {
  token: "p_8z8qtkmbja",
  type: "product",
  name: "add LOGO - Relaxing Gift Set, Lavender Spa Bath Gift Box",
  brandName: "Lizush",
  imageUrl:
    "https://cdn.faire.com/fastly/cd026c2ff20b71b085aa7c07cb397ea9dd4e012626a4f8348f46805e2fc03dfa.jpeg",
  priceDollars: 39,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b66e074b65d4acda4ea8fd133afcfeb5761d5dc4e3fea33f691bef4334bd1ab5/1555020893.jpg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
